module.exports = __webpack_public_path__ + "static/img/202408.428fea3b.png";